import { useState } from "react";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { InfoCircle, X } from "react-bootstrap-icons";

export function ScopePopover({ name, description }) {
    const [show, setShow] = useState(false);

    return (
        <OverlayTrigger
            trigger="click"
            rootClose
            placement="bottom"
            show={show}
            onToggle={() => setShow(!show)}
            overlay={
                <Popover
                    id={`popover-${name}`}
                    style={{
                        maxWidth: "280px",
                        wordWrap: "break-word",
                    }}
                >
                    <Popover.Header
                        as="h3"
                        className="d-flex justify-content-between align-items-center"
                    >
                        <span>{name}</span>
                        <Button
                            variant="link"
                            size="sm"
                            className="p-0"
                            onClick={() => setShow(false)}
                            aria-label="Close"
                        >
                            <X size={18} />
                        </Button>
                    </Popover.Header>
                    <Popover.Body>{description}</Popover.Body>
                </Popover>
            }
        >
            <Button
                variant="link"
                size="sm"
                className="p-0 ms-1"
                style={{ textDecoration: "none", color: "#0d6efd" }}
                onClick={() => setShow(!show)}
            >
                <InfoCircle />
            </Button>
        </OverlayTrigger>
    );
}